/** 工作台「加微信」营销：文案与二维码均在此维护 */
export const WECHAT_CONTACT_PROMO = {
  label: '加企业微信入群赠1000点数',
  subtitle: '长按识别企业微信号二维码，添加并入官方群；添加后将分享文案发给我，领取 1000 点数。',
  qrImageUrl: 'https://oss.bixinpaper.com/cms/wechat/contact-qr.jpg',
  steps: [
    '长按识别上方企业微信号二维码，添加并入官方群',
    '添加后复制下方分享文案发给我，领取 1000 点数'
  ]
}
